const state = {
  administrators: [],
  selectedAdmin: null,
};

const getters = {
  Admins: (state) => state.administrators,
  selectedAdmin: (state) => state.selectedAdmin,
};

const actions = {
  async fetchAdmins({ commit }, { msp_id, user_id }) {
    const response = await this._vm.$http.get(
      `/restapi/admin?msp_id=${msp_id}&user_id=${user_id}`
    );
    commit("setAdmins", response.data);
  },

  async fetchAdmin({ commit, state }, { id, msp_id, user_id }) {
    let query_id = "";
    if (msp_id && user_id) {
      query_id = `?msp_id=${msp_id}&user_id=${user_id}`;
    }
    if (msp_id) {
      query_id = `?msp_id=${msp_id}`;
    }
    if (user_id) {
      query_id = `?user_id=${user_id}`;
    }

    const response = await this._vm.$http.get(
      `/restapi/admin/${id}${query_id}`
    );
    const index = state.administrators.findIndex(
      (admin) => admin.id === response.data.id
    );
    if (index === -1) {
      commit("addAdmin", response.data);
    } else {
      commit("updateAdmin", { idx: index, admin: response.data });
    }
    commit("setSelectedAdmin", response.data);
  },

  async createAdmin({ commit }, { user_id, msp_id, admin }) {
    let query_id = "";
    if (user_id) {
      query_id = `?user_id=${user_id}`;
    } else if (msp_id) {
      query_id = `?msp_id=${msp_id}`;
    }
    const response = await this._vm.$http.post(
      `/restapi/admin/${query_id}`,
      admin
    );
    commit("addAdmin", response.data);
    return response.data;
  },

  async updateAdmin({ commit }, { id, user }) {
    const response = await this._vm.$http.put(`/restapi/admin/${id}`, user);
    commit("updateAdmin", response.data);
  },

  async deleteAdmins({ commit }, admins) {
    const req = {};
    for (const admin of admins) {
      req[`${admin.id}`] = {
        method: "delete",
        path: `admin/${admin.id}?msp_id=${admins.msp_id}&user_id=${admins.user_id}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteAdmins", ids);
  },
};

const mutations = {
  setAdmins: (state, data) => (state.administrators = data.data),
  setSelectedAdmin: (state, data) => (state.selectedAdmin = data),
  addAdmin: (state, data) => state.administrators.push(data),
  updateAdmin: (state, data) =>
    (state.administrators[`${data.idx}`] = data.admin),
  deleteAdmins(state, admins) {
    for (const admin of admins) {
      state.administrators = state.administrators.filter(
        (stateAdmin) => stateAdmin.id !== admin
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
